import { Button } from 'antd';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { setTour } from '@/store/resellerTour/slice';
import { AppRoutes } from 'src/enums/ERoutes';
import { useNavigate } from 'react-router-dom';
import { PlayCircleOutlined } from '@ant-design/icons';
import { Tours } from '@/types/TReseller';

interface TourButtonProps {
	page: keyof Tours;
	onClick?: () => void;
}

const TourButton: React.FC<TourButtonProps> = ({ page, onClick = () => {} }) => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const getStepAndRoute = () => {
		onClick?.();

		switch (page) {
			case 'phone_numbers':
				return AppRoutes.RESELLER_PHONE_NUMBERS;
			case 'email':
				return AppRoutes.RESELLER_EMAIL_CONFIG;
			case 'subscription':
				return AppRoutes.RESELLER_SUBSCRIPTION;
			case 'academy':
				return AppRoutes.RESELLER_ACADEMY;
			case 'branding':
				return AppRoutes.RESELLER_BRANDING;
			case 'contact_support':
				return AppRoutes.RESELLER_CONTACT_SUPPORT;
			case 'twilio':
				return AppRoutes.RESELLER_IMPORT_NUMBER;
			case 'plan_creation':
				return AppRoutes.RESELLER_PLAN_CREATION;
			default:
				return AppRoutes.RESELLER_PORTAL;
		}
	};

	const handleOpenTour = () => {
		const route = getStepAndRoute();
		dispatch(
			setTour({
				open: true,
				currentStep: 0,
				returnTo: route,
			}),
		);
		navigate(route);
	};

	return (
		<Button type="default" size="large" icon={<PlayCircleOutlined />} onClick={handleOpenTour}>
			Open Tour
		</Button>
	);
};

export default TourButton;
